/**
 * <kj-offer-countdown end="2026-11-30T06:00:00Z"> — counts down to a fixed offer end time.
 * Writes days/hours/minutes/seconds into every [data-d], [data-h], [data-m], [data-s] inside it,
 * so a scrolling strip can repeat the timer.
 * When the end time passes, hides [data-countdown-running] and shows [data-countdown-ended].
 */
class KjOfferCountdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const end = Date.parse(this.getAttribute('end') || '');
    if (Number.isNaN(end)) return;

    let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (left === 0) {
      window.clearInterval(this.#timer);
      this.querySelectorAll('[data-countdown-running]').forEach((el) => { el.hidden = true; });
      this.querySelectorAll('[data-countdown-ended]').forEach((el) => { el.hidden = false; });
    }

    const d = Math.floor(left / 86400);
    left -= d * 86400;
    const h = Math.floor(left / 3600);
    left -= h * 3600;
    const m = Math.floor(left / 60);
    const s = left - m * 60;
    const pad = (n) => String(n).padStart(2, '0');
    const set = (sel, v) => {
      this.querySelectorAll(sel).forEach((el) => { el.textContent = pad(v); });
    };
    set('[data-d]', d);
    set('[data-h]', h);
    set('[data-m]', m);
    set('[data-s]', s);
  }
}

if (!customElements.get('kj-offer-countdown')) customElements.define('kj-offer-countdown', KjOfferCountdown);
